import { ActionTypes } from '../constants/index';

export const fetchLoginDetails = (payload: any) => ({
  type: ActionTypes.LOGIN_DETAILS_LIST_REQUEST,
  payload: {
    id: payload.id,
    page: payload.page + 1,
    rowsPerPage: payload.rowsPerPage,
  },
});
